import { getAPIUrls } from './api';
import { bearerHeaders } from './authHeader';

export async function getBaseStatus({ userId, cityIds, environment, bypassCache } = {}) {
  const urls = getAPIUrls();
  const res = await fetch(urls.getBaseStatus, {
    method: 'POST',
    headers: await bearerHeaders(),
    body: JSON.stringify({ userId, cityIds, environment, bypassCache: bypassCache === true })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'BASE_STATUS_FAILED');
  return data;
}

export async function baseCapture({ piUser, userId, cityId, environment } = {}) {
  const urls = getAPIUrls();
  const res = await fetch(urls.baseCapture, {
    method: 'POST',
    headers: await bearerHeaders(),
    body: JSON.stringify({ piUser, userId, cityId, environment })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || 'BASE_CAPTURE_FAILED');
    error.code = data.error;
    throw error;
  }
  return data;
}

export async function reserveBase({ piUser, userId, cityId, environment } = {}) {
  const urls = getAPIUrls();
  const res = await fetch(urls.reserveBase, {
    method: 'POST',
    headers: await bearerHeaders(),
    body: JSON.stringify({ piUser, userId, cityId, environment })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || 'BASE_RESERVE_FAILED');
    error.code = data.error;
    throw error;
  }
  return data;
}

export async function cancelBaseReservation({ piUser, userId, cityId, environment } = {}) {
  const urls = getAPIUrls();
  const res = await fetch(urls.cancelBaseReservation, {
    method: 'POST',
    headers: await bearerHeaders(),
    body: JSON.stringify({ piUser, userId, cityId, environment })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || 'BASE_RESERVE_CANCEL_FAILED');
    error.code = data.error;
    throw error;
  }
  return data;
}
